var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNotificaciones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_notificaciones",
    transform: "translate(-0.726 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_208",
    "data-name": "Rect\\xE1ngulo 208",
    width: 25,
    height: 25,
    transform: "translate(0.726 1)",
    fill: "#5a5a5a",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "wHyvjt.tif",
    transform: "translate(2.726 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_414",
    "data-name": "Trazado 414",
    d: "M16.384,25.1a9.142,9.142,0,0,1-.934-.224,3.146,3.146,0,0,1-1.7-1.421.506.506,0,0,0-.4-.267c-1.35-.215-2.7-.444-4.046-.669-.121-.02-.242-.042-.362-.061a.4.4,0,0,1-.364-.245.365.365,0,0,1,.128-.4,8.206,8.206,0,0,0,1.176-1.534,6.388,6.388,0,0,0,.913-2.789c.073-1.114.054-2.234.087-3.351a8.889,8.889,0,0,1,.1-1.542,4.807,4.807,0,0,1,2.359-3.214,15.031,15.031,0,0,1,1.5-.694,1.748,1.748,0,0,1,.58-1.406,1.572,1.572,0,0,1,1.119-.41A1.687,1.687,0,0,1,18.17,8.71c.248.083.505.158.755.255a4.794,4.794,0,0,1,3.219,4.67c0,1.087,0,2.173.026,3.258a6.8,6.8,0,0,0,.957,3.251A8.573,8.573,0,0,0,24.4,21.8c.11.114.208.233.146.41s-.213.223-.379.251c-1.011.173-2.02.351-3.032.521-.471.08-.943.149-1.416.216a.374.374,0,0,0-.3.2,3.321,3.321,0,0,1-2.34,1.655c-.113.022-.228.035-.342.051Zm7.139-3.217a.253.253,0,0,0-.016-.058c-.035-.047-.071-.092-.108-.137a8.1,8.1,0,0,1-1.93-5.4c.006-.919,0-1.836,0-2.754a3.616,3.616,0,0,0-.049-.694,4.228,4.228,0,0,0-3.107-3.371,5.871,5.871,0,0,0-2.889-.155,4.887,4.887,0,0,0-2.729,1.435,4.105,4.105,0,0,0-1.163,2.949c.008,1.015.017,2.03,0,3.044a7.782,7.782,0,0,1-1.335,4.3c-.191.282-.4.551-.618.847l.969.166a42.4,42.4,0,0,0,5.175.7,19.794,19.794,0,0,0,3.711-.188c1.091-.153,2.177-.349,3.265-.528C22.97,21.988,23.246,21.934,23.523,21.884Zm-9.051,1.45a2.56,2.56,0,0,0,4.163,0A20.906,20.906,0,0,1,14.472,23.334ZM15.532,8.56h1.932a.967.967,0,1,0-1.932,0Z",
    transform: "translate(-6.563 -6.875)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_415",
    "data-name": "Trazado 415",
    d: "M33.568,19.674c-.077.29-.141.584-.235.868a3.563,3.563,0,0,1-.83,1.337c-.175.184-.355.207-.511.069a.34.34,0,0,1,.013-.514,3.157,3.157,0,0,0,.841-1.646,3.111,3.111,0,0,0-.705-2.619c-.053-.065-.112-.125-.165-.191A.334.334,0,0,1,32,16.495a.328.328,0,0,1,.469.037,3.551,3.551,0,0,1,.857,1.343c.1.294.165.6.244.906Z",
    transform: "translate(-13.696 -9.791)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_416",
    "data-name": "Trazado 416",
    d: "M5.689,19.224A3.794,3.794,0,0,1,6.748,16.58c.178-.189.371-.216.523-.076s.146.334-.034.528a3.182,3.182,0,0,0-.115,4.251c.054.065.114.124.165.19a.338.338,0,0,1-.014.471.315.315,0,0,1-.481-.034,6.607,6.607,0,0,1-.659-.9A3.533,3.533,0,0,1,5.689,19.224Z",
    transform: "translate(-5.689 -9.792)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_417",
    "data-name": "Trazado 417",
    d: "M30.6,19.626a2.247,2.247,0,0,0-.535-1.587c-.034-.04-.069-.077-.1-.118a.337.337,0,0,1,.026-.47.326.326,0,0,1,.469.03,2.628,2.628,0,0,1,.682,1.133,2.792,2.792,0,0,1-.656,2.818.333.333,0,0,1-.435.092.3.3,0,0,1-.152-.378.691.691,0,0,1,.146-.222A2.072,2.072,0,0,0,30.6,19.626Z",
    transform: "translate(-13.083 -10.082)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_418",
    "data-name": "Trazado 418",
    d: "M8.111,19.511a2.867,2.867,0,0,1,.742-1.946c.2-.221.386-.258.549-.114s.141.339-.05.559a2.16,2.16,0,0,0-.1,2.794c.051.067.112.125.165.191a.335.335,0,1,1-.493.451,2.767,2.767,0,0,1-.779-1.628C8.127,19.7,8.118,19.586,8.111,19.511Z",
    transform: "translate(-6.429 -10.083)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_419",
    "data-name": "Trazado 419",
    d: "M14.279,14.781a3.247,3.247,0,0,1,2.027-2.714,4.875,4.875,0,0,1,3.985-.021c.225.092.321.248.265.426-.068.216-.244.274-.5.2a8.228,8.228,0,0,0-1.345-.33,3.65,3.65,0,0,0-2.891.828,2.357,2.357,0,0,0-.87,1.729c-.01.251-.163.4-.367.383C14.361,15.261,14.263,15.095,14.279,14.781Z",
    transform: "translate(-8.314 -8.329)",
    fill: "#5a5a5a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificaciones);
export default __webpack_public_path__ + "static/media/ic_notificaciones.92e230daebfaeae15989fdaef388b675.svg";
export { ForwardRef as ReactComponent };